import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="97.304%" id="c">
        <stop stopColor="#FDCC51" offset="0%" />
        <stop stopColor="#F79E13" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#FFDD84" offset="0%" />
        <stop stopColor="#F6BB63" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="25.222%"
        x2="91.089%"
        y2="76.688%"
        id="d"
      >
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M28 8c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 51 31.136c0 5.526-3.422 12.305-7.652 18.275C37.784 57.26 30.73 64 28 64c-2.73 0-9.784-6.74-15.348-14.59C8.422 43.442 5 36.663 5 31.137c0-6.39 2.575-12.174 6.739-16.362C15.9 10.59 21.649 8 28 8Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <g fillRule="nonzero">
        <path
          d="m22.455 29.885 5.396-3.525h2.515l5.398 3.525v9.86H31.84v-3.547c0-1.475-1.23-2.682-2.732-2.682h-.001c-1.502 0-2.732 1.207-2.732 2.682v3.547h-3.921v-9.86Z"
          fill="#FFF"
        />
        <path
          d="M9.414 2.76h2.623V0h2.544v2.76h2.623v2.676h-2.623v2.759h-2.544v-2.76H9.414V2.76ZM.364 16.356c-.182.085-.364.174-.364.382v5.187c0 .208.163.382.363.382h4.83v-8.245l-4.83 2.294Zm25.891 0c.18.085.363.174.363.382v5.187a.374.374 0 0 1-.363.382h-4.83v-8.245l4.83 2.294Z"
          fill="url(#d)"
          transform="translate(15.8 17.437)"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
